import OrderStatusBlock from './OrderStatusBlock';

export default OrderStatusBlock;
